import { useEffect, useState } from 'react';

export const useCountries = (props) => {
  const [countriesData, setCountriesData] = useState({
    countryNames: [],
    countryNamesData: [],
  });
  const firstCountries = Array.isArray(props?.firstCountries)
    ? props?.firstCountries
    : [];

  const awaitCountries = async () => {
    try {
      const data = await getCountries({ firstCountries });
      setCountriesData({
        countryNames: data.finalNameList,
        countryNamesData: data.finalDataList,
      });
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    if (
      countriesData.countryNames.length &&
      countriesData.countryNamesData.length
    )
      return;
    awaitCountries();
  }, []);

  return countriesData;
};

const getCountries = async ({ firstCountries = [] }) => {
  try {
    const data = await import('country-region-data/data.json');
    const initialDataList = data.default;
    const firstCountriesObj = firstCountries.reduce((obj, value) => {
      obj[value] = {};
      return obj;
    }, {});
    const initialNameList = initialDataList.map((item) => {
      if (firstCountriesObj[item.countryName]) {
        firstCountriesObj[item.countryName] = item;
      }
      return item.countryName;
    });
    const finalDataList = [
      ...Object.values(firstCountriesObj),
      ...initialDataList,
    ];
    const finalNameList = [
      ...Object.keys(firstCountriesObj),
      ...initialNameList,
    ];
    return {
      finalDataList,
      finalNameList,
    };
  } catch (error) {
    throw new Error(error);
  }
};
